import BaseService from '@/service/modules/BaseService'
import UserGroupInfo from '@/model/modules/UserGroupInfo'
import BasePageableInfo from '@/model/modules/BasePageableInfo'
import axios from '@/axios'

export default class UserGroupService extends BaseService {
  protected static baseUrl: string = '/group'

  public static list(example: { [index: string]: any }, pageNum: number, pageSize: number): Promise<BasePageableInfo<UserGroupInfo>> {
    example.page = pageNum
    example.size = pageSize
    return new Promise<BasePageableInfo<UserGroupInfo>>((resolve, reject) => {
      axios.get(this.baseUrl + '/group-list', {
        params: example
      }).then(resp => {
        const result: BasePageableInfo<UserGroupInfo> = new BasePageableInfo()
        result.count = resp.data.body.totalElements
        result.dataList = resp.data.body.content
        resolve(result)
      })
    })
  }
}
